// extracted by mini-css-extract-plugin
module.exports = {"vRadiusSmall":"8px","vRadiusMiddle":"12px","list":"MenuList_list__2IBX1","list_normal":"MenuList_list_normal__1-jhk","list_large":"MenuList_list_large__1Gfje"};